import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useLocation } from 'react-router-dom';

// Add FilterConfig interface
interface FilterConfig {
  sideFilterSets: {
    baseSets: {
      [key: string]: Array<{
        key: string;
        label: string;
        type: string;
        options: Array<{
          label: string;
          value: string;
        }>;
      }>;
    };
    contextualFilters: {
      [key: string]: {
        [key: string]: string[];
      };
    };
  };
  parentOptions: Array<{
    key: string;
    label: string;
    value: string;
    isDefault?: boolean;
    kpiOptions: KpiOption[];
  }>;
}

interface KpiOption {
  key?: string;
  label?: string;
  value?: string;
  kpiFilter: string;
  kpiCategory?: string;
  isDefault?: boolean;
  programType?: string;
  programSequence?: number;
}

interface FilterOption {
  label: string;
  value: string;
  // kpiOptions: KpiOption[];
}

interface KpiFilter {
  kpiCategory: string;
  kpiFilter: string;
}

interface ProgramState {
  selectedKpiOption: FilterOption | null;
  filterOptions: FilterOption[];
  filterConfig: FilterConfig | null;
  selectedKpiTab: KpiOption | null;
  activeTab: number;
  selectedKpiFilter: KpiFilter | null;
  programName: string | null; // Add this line
}

const initialState: ProgramState = {
  selectedKpiOption: null,
  filterOptions: [],
  filterConfig: null,
  selectedKpiTab: null,
  activeTab: 0,
  selectedKpiFilter: null,
  programName: null // Add this line
};

const ProgramDataSlice = createSlice({
  name: "programState",
  initialState,
  reducers: {
    setSelectedKpiOption: (state, action: PayloadAction<FilterOption>) => {
      // Update URL params
      const params = new URLSearchParams(window.location.search);
      if (action.payload) {
        params.set('parentFilter', JSON.stringify(action.payload));
      } else {
        params.delete('parentFilter');
      }
      state.selectedKpiOption = action.payload;
      
      // Update URL without page reload
      window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
    },

    setSelectedKpiTab: (state, action: PayloadAction<KpiOption>) => {
      
      
      // Update URL params
      const params = new URLSearchParams(window.location.search);
      if (action.payload) {
        state.selectedKpiTab = action.payload;
        params.set('selectedKpiFilter', JSON.stringify(action.payload));
      } else {
        state.selectedKpiTab = null;

        params.set('selectedKpiFilter', '');
        params.delete('selectedKpiFilter');
      }
      window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
    },

    setFilterOptions: (state, action: PayloadAction<FilterOption[]>) => {
      state.filterOptions = action.payload;
    },

    setFilterConfig: (state, action: PayloadAction<FilterConfig>) => {
      state.filterConfig = action.payload;
    },
    resetRegistrationParams: (state) => {
      // Reset state
      state.selectedKpiOption = null;
      state.selectedKpiTab = null;
      
      // Clear URL params
      const params = new URLSearchParams(window.location.search);
      const currentParams = new URLSearchParams(params.toString());
      
      // Remove only our specific params while keeping others
      currentParams.delete('parentFilter');
      currentParams.delete('selectedKpiFilter');
      
      // Update URL with remaining params or just pathname if no params left
      // Update URL to only pathname without any search params
      window.history.replaceState({}, '', window.location.pathname);
   
    },
    resetProgramState: (state) => {
      // Reset all state
      state.selectedKpiOption = null;
      state.filterOptions = [];
      state.filterConfig = null;
      state.selectedKpiTab = null;
      state.activeTab = 0;
      state.selectedKpiFilter = null;

      // // Use window.location instead of useLocation hook
      // const params = new URLSearchParams(window.location.search);
      // params.delete('selectedKpiFilter');
      // params.delete('parentFilter');

    },
    setActiveTab: (state, action: PayloadAction<number>) => {
      state.activeTab = action.payload;
    },
    setSelectedKpiFilter: (state, action: PayloadAction<KpiFilter | null>) => {
      state.selectedKpiFilter = action.payload;
      // const params = new URLSearchParams(window.location.search);
      // params.set('selectedKpiFilter', JSON.stringify(action.payload));
    },
    setProgramName: (state, action: PayloadAction<string>) => {
      state.programName = action.payload;
    },
  }
});

export const {
  setSelectedKpiOption,
  setFilterOptions,
  setFilterConfig,
  setSelectedKpiTab,
  resetProgramState,
  resetRegistrationParams,
  setActiveTab,
  setSelectedKpiFilter,
  setProgramName, // Add this line
} = ProgramDataSlice.actions;

export default ProgramDataSlice.reducer;
